import React, {useContext, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {
    Button,
    Grid,
    GridColumn,
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Select,
    TextField,
    TMultipleSelectValue,
} from '../../../patterns';
import {StoreContext} from '../base/root-store';

export const AddAndEditMatrixTeamModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).companyStore;
    const initialMatrixTeam = store.variables.matrixTeamInEditing;
    const initialMatrixTeamManagerId = initialMatrixTeam && initialMatrixTeam.managerId ? initialMatrixTeam.managerId : 'no-manager';

    const [matrixTeamName, setMatrixTeamName] = useState<string>(initialMatrixTeam ? initialMatrixTeam.matrixTeamName : '');
    const [managerId, setManagerId] = useState<string>(initialMatrixTeamManagerId);
    const [childTeams, setChildTeams] = useState<TMultipleSelectValue | undefined>(initialMatrixTeam ? store.getChildBusinessUnitIds(initialMatrixTeam) : ['']);

    const handleSave = (): void => {
        const updatedChildTeams = !childTeams || childTeams.length === 0 || (childTeams.length === 1 && childTeams[0] === '')
            ? [] : childTeams;

        store.saveMatrixTeam({
            childBusinessUnitIds: updatedChildTeams.length > 0 ? updatedChildTeams : []
            ,
            matrixTeamName,
            managerId: managerId === 'no-manager' ? undefined : managerId,
        });
    };

    return (
        <Modal size="small">
            <ModalHeader>
                <h4>{store.variables.openModal==='add-matrix-team' ? store.label('company.matrix-team-modal.title-add') : store.label('company.matrix-team-modal.title-edit')}</h4>
            </ModalHeader>
            <ModalContent>
                <div className="text">
                    <TextField
                        label={store.label('company.matrix-team-modal.insert-team-name')}
                        focusLabel={initialMatrixTeam ? store.label('company.matrix-team-modal.edit-team-name'): store.label('company.department-modal.insert-business-unit')}
                        defaultValue={matrixTeamName}
                        onChange={((value): void => setMatrixTeamName(value))}
                        id='add-team-name'
                        name='add-team-name'
                        description={store.variables.showValidation && store.getNameError(matrixTeamName, 'matrix_name_forbidden') !== undefined ? store.label(`common.validation.${store.getNameError(matrixTeamName, 'matrix_name_forbidden')}`) : undefined}
                        invalid={store.variables.showValidation && store.getNameError(matrixTeamName, 'matrix_name_forbidden') !== undefined}
                    />
                    <Select
                        label={store.label('company.matrix-team-modal.select-manager')}
                        defaultValue={managerId}
                        onChange={(value): void => setManagerId('' + value)}
                        options={[
                            {
                                label: store.label('company.matrix-team-modal.no-manager'),
                                value: 'no-manager',
                            },
                            ...store.payload!.allEmployeesPayload.allEmployees.map((employee) => ({
                                label: employee.employeeFirstName.concat(' '+ employee.employeeLastName),
                                value: employee.employeeId,
                            })).sort((a,b) => a.label.localeCompare(b.label))]}
                        search={{
                            label: store.label('company.matrix-team-modal.search-manager'),
                            id: 'add-team-lead-search',
                            name: 'add-team-lead-search',
                        }}
                        id='add-team-lead-name'
                        name='add-team-lead-name'
                        type={undefined}
                    />
                    <Select
                        label={store.label('company.matrix-team-modal.select-child-teams')}
                        defaultValue={childTeams}
                        onChange={(value): void => setChildTeams(value)}
                        options={[
                            {
                                label: store.label('company.matrix-team-modal.no-children'),
                                value: '',
                            },
                            ...store.getBusinessUnits().map((businessUnit) => ({
                                label: businessUnit.businessUnitName,
                                value: businessUnit.id,
                            })).sort((a,b) => a.label.localeCompare(b.label))]}
                        search={{
                            label: store.label('company.matrix-team-modal.search-child-teams'),
                            id: 'child-teams-search',
                            name: 'child-teams-search',
                        }}
                        id='select-child-teams'
                        name='select-child-teams'
                        type={'multiple'}
                    />
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['between-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text={store.label('company.modal.cancel')}/>
                        </ModalCloser>
                    </GridColumn>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <Button
                            block={true}
                            text={store.label('company.modal.save')}
                            onClick={handleSave}
                        />
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
